import styled, { css } from "styled-components";

const StyledButton = styled.button`
    width: 100%;
    @media only screen and (min-width: ${props => props.theme.smallTablet}) {
        width: auto;
    }

    /* primary */
    ${props => {
        return (
            props.link &&
            css`
                color: ${props.theme.white};
            `
        );
    }}
`;

export default StyledButton;
